import { apiFetch } from "@/lib/api";

export type ClampQcInspectionSlotReserveResponse = {
  buildOrderId: number;
  serialKey: number;
  slotOrdinal: number;
  requiresInductance: boolean;
  plannedQuantity: number;
  inductanceTestingTargetCount: number;
  inductanceTestingPercentPerWorkOrder: number;
};

export async function postClampQcInspectionSlotReserve(input: {
  buildOrderId: number;
  serialKey: number;
}): Promise<ClampQcInspectionSlotReserveResponse> {
  return apiFetch<ClampQcInspectionSlotReserveResponse>("/api/clamp-qc/inspection-slot/reserve", {
    method: "POST",
    body: {
      buildOrderId: input.buildOrderId,
      serialKey: input.serialKey,
    },
  });
}
